import SectionHeader from "../../include/SectionHeader";

const VissionMission = () => {
    return (
        <>
        <div className="aboutus_vismis_section py-5 my-3">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 mb-3">
                        <SectionHeader title={"Vission Mission"} subtitle={"Lifeline Tulasi Hospital - Adding value and delivering for 28 years."} />
                    </div>
                    <div className="col-md-5 mb-4 mb-md-0">
                        <div className="vm-content-wrapper">
                            <div className="icon-wrapper">
                                <img src="/assets/img/vission-img.png" alt="vission-img" className="img-fluid" />
                            </div>
                            <p className="icon-title">Vision</p>
                            <p className="main-content">
                                To be a leading multispeciality hospital, excelling in emergency care, cardiology, and advanced minimally invasive surgeries—bringing together the finest medical expertise, cutting-edge technology, and a patient-first approach.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="vm-content-wrapper">
                            <div className="icon-wrapper">
                                <img src="/assets/img/mission-img.png" alt="vission-img" className="img-fluid" />
                            </div>
                            <p className="icon-title">Mission</p>
                            <p className="main-content">
                                Driven by unmatched focus, unyielding diligence, and uncompromising ethics, we deliver compassionate, accessible, and comprehensive high-quality healthcare that enhances lives and protects the health of our community.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default VissionMission;
